import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { HINT } from '../../../constants';
import { Context } from '../Context';
const Hint = forwardRef(({ as: Element = 'p', children, render, ...rest }, ref) => {
    const { id, isInvalid, isLoading, isRequired } = useContext(Context);
    return (_jsx(Element, { ref: ref, id: `${id}-description`, ...rest, children: render ? render({ isInvalid, isLoading, isRequired }) : children }));
});
Hint.displayName = HINT;
export { Hint };
//# sourceMappingURL=Hint.js.map